__turbopack_context__.v({
  "authContainer": "auth-module__Y2OPrW__authContainer",
  "authFooter": "auth-module__Y2OPrW__authFooter",
  "authFooterContent": "auth-module__Y2OPrW__authFooterContent",
  "authWrapper": "auth-module__Y2OPrW__authWrapper",
  "fadeInSmooth": "auth-module__Y2OPrW__fadeInSmooth",
  "loaded": "auth-module__Y2OPrW__loaded",
  "rightContent": "auth-module__Y2OPrW__rightContent",
  "rightPanel": "auth-module__Y2OPrW__rightPanel",
});
